var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4720_44480",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4720_44480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0469 19.5C9.94688 19.5 8.17187 18.775 6.72187 17.325C5.27187 15.875 4.54688 14.1 4.54688 12C4.54688 9.9 5.27187 8.125 6.72187 6.675C8.17187 5.225 9.94688 4.5 12.0469 4.5C13.2135 4.5 14.3179 4.75833 15.3599 5.275C16.4012 5.79167 17.2635 6.525 17.9469 7.475V4.5H19.4469V10.625H13.3469V9.125H17.2969C16.7635 8.15833 16.0302 7.396 15.0969 6.838C14.1635 6.27933 13.1469 6 12.0469 6C10.3802 6 8.96354 6.58333 7.79688 7.75C6.63021 8.91667 6.04688 10.3333 6.04688 12C6.04688 13.6667 6.63021 15.0833 7.79688 16.25C8.96354 17.4167 10.3802 18 12.0469 18C13.3302 18 14.4885 17.6333 15.5219 16.9C16.5552 16.1667 17.2802 15.2 17.6969 14H19.2719C18.8219 15.6333 17.9262 16.9583 16.5849 17.975C15.2429 18.9917 13.7302 19.5 12.0469 19.5Z",
    fill: "#262C6E",
    fillOpacity: 0.8
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.04782eeb996a1d0505a4ab2bf95a4a85.svg";
export { ForwardRef as ReactComponent };